import { createLazyModuleLoader } from './lazyModuleLoader.js';

export function createMusicDomainRuntime(context = {}) {
  const {
    importWithChunkRecovery,
    state,
    elements,
    showToast,
    formatDate,
    openModal,
    closeModal,
    addMusic,
    updateMusic,
    deleteMusic,
    addPodcast,
    updatePodcast,
    deletePodcast,
    canAccessFeature = () => true,
    openMembershipCenter = () => {}
  } = context;

  let musicModuleApi = null;
  let musicModuleLoadingPromise = null;
  let musicPlayerInitPromise = null;

  const loadMusicModule = createLazyModuleLoader({
    importWithChunkRecovery,
    importer: () => import('./musicModule.js'),
    getApi: () => musicModuleApi,
    setApi: (mod) => {
      musicModuleApi = mod;
    },
    getLoadingPromise: () => musicModuleLoadingPromise,
    setLoadingPromise: (promise) => {
      musicModuleLoadingPromise = promise;
    }
  });

  async function ensureMusicPlayerReady() {
    if (state.music.initialized) return;
    if (!musicPlayerInitPromise) {
      musicPlayerInitPromise = (async () => {
        const mod = await loadMusicModule();
        await mod?.initMusicPlayerModule?.({
          state,
          elements,
          showToast,
          formatDate,
          openModal,
          closeModal,
          addMusic,
          updateMusic,
          deleteMusic,
          addPodcast,
          updatePodcast,
          deletePodcast,
          canAccessFeature,
          openMembershipCenter
        });
        state.music.initialized = true;
      })().finally(() => {
        musicPlayerInitPromise = null;
      });
    }
    await musicPlayerInitPromise;
  }

  return {
    ensureMusicPlayerReady,
    getMusicModuleApi: () => musicModuleApi
  };
}
